import React, { useState, useEffect, useCallback } from 'react';
import api from '../../../services/api';
import { Button } from '../../ui/button';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const fmt = (n) => Number(n || 0).toLocaleString('pt-BR');
const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit',
      hour: '2-digit', minute: '2-digit' });
  } catch { return '-'; }
};
const STATUS = ['SUCCESS_HIT', 'SUCCESS_BLOCKED', 'FAILED'];

export default function OilAdminMafia({ seasonId, services = [] }) {
  const [log, setLog] = useState(null);
  const [stats, setStats] = useState(null);
  const [total, setTotal] = useState(0);
  const [skip, setSkip] = useState(0);
  const [f, setF] = useState({ service: '', status: '', attacker: '', target: '' });

  const load = useCallback(async () => {
    try {
      const [l, s] = await Promise.all([
        api.get(`/admin/oil/season/${seasonId}/mafia-log`, {
          params: { skip, limit: 30, ...Object.fromEntries(Object.entries(f).filter(([, v]) => v)) } }),
        api.get(`/admin/oil/season/${seasonId}/mafia-stats`, { params: { period: 'today' } }),
      ]);
      setLog(l.data.attacks || []);
      setTotal(l.data.total || 0);
      setStats(s.data.services || []);
    } catch { toast.error('Erro ao carregar registro da Máfia.'); }
  }, [seasonId, skip, f]);
  useEffect(() => { const t = setTimeout(load, 300); return () => clearTimeout(t); }, [load]);

  const set = (k, v) => { setF((p) => ({ ...p, [k]: v })); setSkip(0); };

  return (
    <div className="space-y-3" data-testid="oil-admin-mafia">
      <div className="rounded-xl border p-3" data-testid="oil-mafia-stats">
        <p className="mb-1 text-xs font-black uppercase text-slate-600">Serviços de hoje — chance real x configurada</p>
        {!stats ? <Loader2 className="h-4 w-4 animate-spin text-orange-500" /> : (
          <div className="overflow-x-auto">
            <table className="w-full text-[11px]">
              <thead className="text-[10px] uppercase text-slate-400">
                <tr><th className="p-1 text-left">Serviço</th><th className="p-1">Usos</th><th className="p-1">Acertos</th>
                  <th className="p-1">Real</th><th className="p-1">Config</th><th className="p-1">Respeito</th>
                  <th className="p-1">Dano FOX</th><th className="p-1">Carga</th><th className="p-1">Instalação</th></tr>
              </thead>
              <tbody>
                {stats.map((s) => (
                  <tr key={s.service_id} className="border-t" data-testid={`oil-mafia-stat-${s.service_id}`}>
                    <td className="p-1 text-left font-bold">{s.name}</td>
                    <td className="p-1 text-center">{fmt(s.uses)}</td>
                    <td className="p-1 text-center">{fmt(s.hits)}</td>
                    <td className="p-1 text-center font-black">{s.real_pct}%</td>
                    <td className="p-1 text-center text-slate-500">{s.configured_pct}%</td>
                    <td className="p-1 text-center">{fmt(s.respect)}</td>
                    <td className="p-1 text-center">{fmt(s.damage)}</td>
                    <td className="p-1 text-center">{fmt(s.cargo)}</td>
                    <td className="p-1 text-center">{fmt(s.facility)}</td>
                  </tr>
                ))}
                {stats.length === 0 && <tr><td colSpan={9} className="p-2 text-center text-slate-400">Nenhuma operação hoje.</td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <select value={f.service} onChange={(e) => set('service', e.target.value)} data-testid="oil-mafia-filter-service"
          className="h-9 rounded-lg border bg-white px-2 text-xs">
          <option value="">Todos os serviços</option>
          {services.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
        <select value={f.status} onChange={(e) => set('status', e.target.value)} data-testid="oil-mafia-filter-status"
          className="h-9 rounded-lg border bg-white px-2 text-xs">
          <option value="">Todos os resultados</option>
          {STATUS.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <input value={f.attacker} onChange={(e) => set('attacker', e.target.value)} placeholder="KAKO do atacante"
          data-testid="oil-mafia-filter-attacker" className="h-9 w-40 rounded-lg border px-2 text-xs" />
        <input value={f.target} onChange={(e) => set('target', e.target.value)} placeholder="KAKO do alvo"
          data-testid="oil-mafia-filter-target" className="h-9 w-40 rounded-lg border px-2 text-xs" />
        <span className="text-xs text-slate-500" data-testid="oil-mafia-total">{fmt(total)} operações</span>
      </div>

      {!log ? <div className="flex justify-center py-6"><Loader2 className="h-5 w-5 animate-spin text-orange-500" /></div> : (
        <div className="overflow-x-auto rounded-xl border">
          <table className="w-full text-[11px]">
            <thead className="bg-slate-50 text-[10px] uppercase text-slate-500">
              <tr><th className="p-2 text-left">Data</th><th className="p-2 text-left">Atacante</th>
                <th className="p-2 text-left">Alvo</th><th className="p-2 text-left">Serviço</th>
                <th className="p-2">Resultado</th><th className="p-2">Custo</th><th className="p-2">Dano FOX</th>
                <th className="p-2">Carga</th><th className="p-2">Instalação</th><th className="p-2">Respeito</th></tr>
            </thead>
            <tbody>
              {log.map((a) => (
                <tr key={a.attack_id} className="border-t" data-testid={`oil-mafia-row-${a.attack_id}`}>
                  <td className="p-2">{fmtDate(a.created_at)}</td>
                  <td className="p-2">{a.attacker_nickname || '—'} <span className="text-slate-400">{a.attacker}</span></td>
                  <td className="p-2">{a.target_nickname || '—'} <span className="text-slate-400">{a.target}</span></td>
                  <td className="p-2">{a.service_id}</td>
                  <td className="p-2 text-center">
                    <span className={`rounded-full px-2 py-0.5 font-bold ${
                      a.status === 'SUCCESS_HIT' ? 'bg-emerald-100 text-emerald-700'
                        : a.status === 'SUCCESS_BLOCKED' ? 'bg-sky-100 text-sky-700' : 'bg-slate-100 text-slate-600'}`}>
                      {a.status}
                    </span>
                  </td>
                  <td className="p-2 text-center">{fmt(a.cost)}</td>
                  <td className="p-2 text-center">{fmt(a.damage)}</td>
                  <td className="p-2 text-center">{fmt(a.cargo_barrels)}</td>
                  <td className="p-2 text-center">{fmt(a.facility_damage)}</td>
                  <td className="p-2 text-center">{fmt(a.respect)}</td>
                </tr>
              ))}
              {log.length === 0 && <tr><td colSpan={10} className="p-3 text-center text-slate-400">Nenhuma operação com esses filtros.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
      <div className="flex items-center gap-2">
        <Button size="sm" variant="outline" disabled={skip === 0} data-testid="oil-mafia-prev"
          onClick={() => setSkip(Math.max(0, skip - 30))}>Anterior</Button>
        <Button size="sm" variant="outline" disabled={skip + 30 >= total} data-testid="oil-mafia-next"
          onClick={() => setSkip(skip + 30)}>Próximos</Button>
      </div>
    </div>
  );
}
